import { createContext, useState } from "react";

export const CSVUploadContext = createContext();

export const CSVUploadContextProvider = ({ children }) => {
    const [uploadedFile, setUploadedFile] = useState({});

    const contextValue = {
        uploadedFile,
        setUploadedFile,
    };

    return (
        <CSVUploadContext.Provider value={ contextValue }>
            { children }
        </CSVUploadContext.Provider>
    );
}
